const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export const validateContactForm = (formData) => {
  const errors = {};

  if (!formData.name || formData.name.trim() === "") {
    errors.name = "Please enter your name.";
  }

  if (!formData.email || formData.email.trim() === "") {
    errors.email = "Please enter your email address.";
  } else if (!emailPattern.test(formData.email.trim())) {
    errors.email = "Please enter a valid email address.";
  }

  if (!formData.subject || formData.subject.trim() === "") {
    errors.subject = "Please enter an inquiry subject.";
  }

  if (!formData.message || formData.message.trim() === "") {
    errors.message = "Please enter your project message.";
  }

  if (formData.company && formData.company.trim() === "") {
    errors.company = "Company name cannot be just spaces.";
  }

  if (formData.phone) {
    const phoneTrimmed = formData.phone;
    if (!/^\+\d+$/.test(phoneTrimmed)) {
      errors.phone =
        "Phone number must start with a '+' followed by digits (e.g. +48XXXXXXXX).";
    }
  }

  return errors;
};